export default __webpack_public_path__ + "static/media/Javascript.25c00c21.png";